import { useEffect } from 'react'

import { authCallbackUrl } from '@mntn-dev/app-routing'
import { clientAuthConfig } from '@mntn-dev/authentication-types'

export const redirectToSignIn = ({
  redirect_url,
}: {
  redirect_url?: string
}) => {
  const { signInUrl } = clientAuthConfig()

  useEffect(() => {
    window.location.href = `${signInUrl}?${new URLSearchParams({ redirect_url: redirect_url || authCallbackUrl() })}`
  }, [signInUrl, redirect_url])
}
